import { render, staticRenderFns } from "./DemoFileInputShowSize.vue?vue&type=template&id=52a2bde4&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
